import { render, staticRenderFns } from "./SendLibationBoxCeremonyNotice.vue?vue&type=template&id=97c1320a"
import script from "./SendLibationBoxCeremonyNotice.vue?vue&type=script&lang=js"
export * from "./SendLibationBoxCeremonyNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports